export default "__VITE_ASSET__CXMsV82___"